"use strict";

Shopify.theme.jsShippingCalculator = {
  init: function init($section) {
    if (Shopify.theme_settings.shipping_calculator_enabled) {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: Shopify.translation.shipping_calculator_submit_btn,
        submitButtonDisabled: Shopify.translation.shipping_calculator_submit_btn_disabled,
        customerIsLoggedIn: Shopify.theme_settings.customer_logged_in,
        moneyFormat: Currency.money_format_currency
      });
    }
  },
  unload: function unload($section) {}
};